module.exports = __webpack_public_path__ + "static/media/vario-logo.9044685e.svg";